(function (angular) {
    'use strict';

    angular.module('app')
        .controller('resourceController', resourceController);

    resourceController.$inject = [
        '$rootScope',
        'resourcePayload',
        '$uibModal',
        '$scope',
        'alerts',
        'LikesApi',
        'CommentsApi',
        'UsersApi',
        'thisUser',
    ];

    function resourceController(
        $rootScope,
        resourcePayload,
        $uibModal,
        alerts,
        LikesApi,
        CommentsApi,
        UsersApi,
        thisUser,
        $scope
    ) {
        var vm = this;

        // properties
        vm.thisUser = $rootScope.thisUser;
        vm.resource = resourcePayload;

        // methods
        vm.getLikes = getLikes;
        vm.getComments = getComments;
        vm.getLikesAndComments = getLikesAndComments;

        vm.postComment = postComment;

        vm.toggleLike = toggleLike;
        vm.toggleComments = toggleComments;
        vm.saveReply = saveReply;

        vm.authenticated = thisUser !== null;

        vm.likesAndCommentsFilter = {
            filter_by: null,
            order_by: 'created_at',
            order: 'desc',
            user_id: null,
        }

        vm.usersFilter = {
            filter_by: null,
            order_by: 'created_at',
            order: 'desc',
            user_id: null,
        }

        vm.likes = [];
        vm.comments = [];
        const replyFormat = {
            id: null,
            parent_id: null,
            body: '',
            entities: [],
            item_id: null,
            item_type: 'resource',
            saving: false,
        };

        enum API_ROUTE {
            LIKES = '/api/likes',
            COMMENTS = '/api/comments',
        }

        vm.likedByUser = (resourceId) => {
            const user = vm.resource.find(f => f.id === resourceId);

            if (!user) return false;

            return user.likes.filter(x => x.user_id === thisUser.id).length > 0;
        }

        function extendUserData(list: object[]) {
            const handleSuccess = (response) => {
                const { data } = response;

                list.map((item: any) => {
                    const user = data.find(x => x.id === item.user_id);

                    if (user) {
                        const { id, full_name, slug, img, initials } = user;
                        item['user'] = { id, full_name, slug, img, initials };
                    }
                });
                return list;
            }

            UsersApi.get(vm.usersFilter, handleSuccess);
            return list ?? [];
        }

        function getLikes(resourceId = null) {
            const handleResponse = (response) => {
                const { data } = response;

                if (!resourceId) {
                    vm.likes = data.length ? extendUserData(data) : [];
                }
                else {
                    const resource = vm.resources.find(i => i.id === resourceId);

                    if (!resource) return;

                    resource['showFooter'] = thisUser !== null;
                    resource['likes'] = data.length ? extendUserData(data) : [];
                    if ($scope.authenticated) {
                        resource['liked'] = resource.likes.filter((like) => like.user_id === thisUser.id).length > 0;
                    }
                }
            }

            const filters = vm.likesAndCommentsFilter;

            if (resourceId) {
                filters['item_id'] = resourceId;
            }

            return LikesApi.get(filters, handleResponse);
        }

        function getComments(resourceId = null) {
            let resource;

            const handleResponse = response => {
                const { data } = response;

                if (!resourceId) {
                    vm.comments = data.length ? extendUserData(data) : [];
                }
                else {
                    resource = vm.resources.find(i => i.id === resourceId);
                    
                    if (!resource) return;
                    resource['comments'] = data.length ? extendUserData(data) : [];
                    resource['surfaceComments'] = resource.comments.filter(comment => comment.parent_id === null);
                    resource['replies'] = resource.comments.filter(comment => (
                        comment.parent_id === resourceId
                    ))

                    if (resource['liked'] !== undefined && $scope.authenticated) {
                        resource.liked = resource.likes.filter((like) => like.user_id === thisUser.id).length > 0;
                    }

                    if (resource.comments.length) {
                        resource.comments.map(comment => {
                            comment['isReply'] = comment.parent_id != null;
                            comment['parent'] = null;
                            comment['replies'] = [];
                            comment['deleted'] = false;
        
                            if (comment.isReply && !resource.comments.find(c => c.id === comment.parent_id)) {
                                comment['deleted'] = true;
                            }
        
                            if (comment['isReply']) {
                                comment['parent'] = resource.comments.find(c => c.id === comment.parent_id) ?? null;
                                comment['parentId'] = comment.parent ? comment.parent.id : null;
                                comment['replies'] = resource.comments.filter(c => c.parent_id === comment.id);
                            }
                            else {
                                comment['replies'] = resource.comments.filter(c => c.parent_id === comment.id);
                            }
                        });
                    }
                }
            }

            const filters = vm.likesAndCommentsFilter;

            if (resourceId) {
                filters['item_id'] = resourceId;
            }

            return CommentsApi.get(filters, handleResponse);
        }

        async function getLikesAndComments() {
            if (vm.resources) {
                vm.resources.map(resource => {
                    const { id, itemType, user } = resource;

                    if (resource['likes'] === undefined) resource['likes'] = [];
                    if (resource['liked'] === undefined) resource['liked'] = false;
                    if (resource['comments'] === undefined) resource['comments'] = [];
                    if (resource['replies'] === undefined) resource['replies'] = [];
                    if (resource['commentsLoading'] === undefined) resource['commentsLoading'] = false;
                    if (resource['showComments'] === undefined) resource['showComments'] = false;

                    if (itemType === 'resource') {
                        vm.getLikes(id);
                        vm.getComments(id);

                        if ($scope.authenticated && resource['liked'] !== undefined) {
                            resource.liked = resource.likes.filter(like => like.user_id === thisUser.id).length > 0;
                        }
                    }
                })
            }
        }

        function toggleComments(resourceId) {
            if (!resourceId) return;

            const resource = vm.resources.find(item => item.id === resourceId);
            
            if (!resource.showComments) vm.getComments(resourceId);
            resource.showComments = !resource.showComments;
        }

        function toggleReplyBox(resourceId, state = null) {
            if (state != null && typeof state !== 'boolean') return;

            if (state === null) {
                return $scope.replyBoxOpen = !$scope.replyBoxOpen;
            }

            if (!resourceId) return;

            const resource = vm.resources.find(item => item.id == resourceId);
            if (!resource) return;

            return resource.replyBoxOpen = state;
        }

        /**
         * Toggles a User's *like* on a resource
         * @return {void}
         */
        function toggleLike(resourceId) {
            if (!resourceId) return;

            const resource = vm.resources.find(item => item.id === resourceId);
            if (!resource) return;

            // vm.getLikes();

            const method = resource.liked ? 'DELETE' : 'POST';

            // If isLikedByUser is TRUE then we use the DELETE route with the DELETE method.
            // Otherwise, we use the POST route to creat a new Like.

            const likeObj = resource.likes.find(x => x.item_id === resourceId && x.user_id === thisUser.id)

            // if (!likeObj) return;

            const endpoint = resource.liked
                ? `/${likeObj.id}`
                : `?item_type=${resource.itemType}&item_id=${resourceId}`;

            fetch(API_ROUTE.LIKES + endpoint, { method }).then((res) => {
                vm.getLikes(resourceId);
            });
        }

        async function updateComment(fetchMethod, commentData): Promise<any> {
            if (fetchMethod === 'GET') return false;

            const { id, parentId, itemId, body, entities = [] } = commentData;
            let endpoint = `${API_ROUTE.COMMENTS}`;
            
            switch (fetchMethod.toUpperCase()) {
                case 'DELETE':
                    endpoint = `${endpoint}/${id}`;
                    break;
                case 'PUT':
                    endpoint = `${endpoint}/${id}?body=${body}`; // IMPLEMENT ENTITIES HERE
                    break;
                case 'POST':
                    endpoint = `${endpoint}?item_type=resource&item_id=${$scope.resource.id}&body=${body}`;
                    if (parentId) endpoint = `${endpoint}&parent_id=${parentId}`;
                    break;
                default:
                    throw Error('[updateComment] Unexpected fetchMethod: ' + fetchMethod);
            }

            const promise = await fetch(endpoint, { method: fetchMethod }).then(res => res.json());
            return Promise.resolve(promise);
        }
        
        function postComment(resourceId = null) {
            if (!resourceId) return false;

            if ($scope.reply.body) {
                let { id = null, item_id, body } = $scope.reply;
                const method = id != null ? 'PUT' : 'POST';

                if (!item_id) {
                    item_id = resourceId;
                }

                $scope.reply.saving = true;

                updateComment(method, { itemId: item_id, body }).then((res) => {
                    $scope.reply = replyFormat;
                    $scope.reply.body = '';
                    $scope.reply.saving = false;
                    toggleReplyBox(false);
                    getComments(resourceId);
                })
            }
        }

        async function saveReply(resourceId) {
            $scope.reply.saving = true;

            await vm.updateComment('POST', $scope.reply).then((res) => {
                $scope.reply.saving = false;
                vm.getComments(resourceId);
            })
        }
        function bootstrap() {
            vm.isLoading = false;

            // console.log('$scope.authenticated', $scope.authenticated);

            document.body.addEventListener('comments:refresh', function () {
                vm.getLikesAndComments();
            }, false);
        }
        
        bootstrap();
    }
    

}(angular));